import { ProjectPermissionProps } from './types/projectPermission.ts';
import { useHasProjectPermission } from './useHasProjectPermission.ts';
import { useAuth } from '../auth/auth-interceptor.ts';

type PermissionGateProps = ProjectPermissionProps & {
  children: React.ReactNode;
  placeholder?: React.ReactNode;
  allowForAdmin?: boolean;
};

export function PermissionGate({
  permissions,
  children,
  allowForAdmin,
  placeholder,
  ignoreFeatureFlag,
}: PermissionGateProps) {
  const auth = useAuth();
  const authData = auth !== 'loading' ? auth : null;
  const isSuperAdmin = !!authData?.claims.isSuperAdmin;

  const hasPermission = useHasProjectPermission();

  const canView =
    (allowForAdmin && isSuperAdmin) ||
    hasPermission(permissions, ignoreFeatureFlag);
  return canView ? children : (placeholder ?? null);
}
